/**
 * Utility functions for handling image URLs in the Tyrrst app
 * Ensures images work properly in both development and production environments
 */

// Get the API base URL from environment
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/';
const PROD_URL = 'https://tyrrst.com/api/';

/**
 * Fixes image URLs to ensure they work properly in the current environment
 * Replaces production URLs with local development URLs when running locally
 * 
 * @param {string} url - The original image URL from the API
 * @returns {string} - The corrected image URL
 */
export const fixImageUrl = (url) => {
  if (!url) return ''; // Return empty string for null/undefined
  
  // If the URL is already relative or using the correct base, return as is
  if (!url.includes('://') || url.startsWith(API_BASE_URL)) {
    return url;
  }
  
  // Replace production URL with local development URL
  if (url.startsWith(PROD_URL)) {
    return url.replace(PROD_URL, API_BASE_URL);
  }
  
  // If it's an absolute URL with a different domain, we can't fix it
  // So we return it as is
  return url;
};

export default { fixImageUrl };
